module.exports = __webpack_public_path__ + "static/media/warningfill.628aedda.svg";